"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const one_1 = require("remax/one");
const classnames_1 = __importDefault(require("classnames"));
const icon_1 = __importDefault(require("../icon"));
const common_1 = require("../common");
const prefixCls = common_1.getPrefixCls('cell');
const Cell = (props) => {
    const { label, style, labelStyle, valueStyle, children, description, verticality, icon, border = true, arrow, required, field, defaultNullValue = '', onTap, } = props;
    if (verticality) {
        return (React.createElement(one_1.View, { className: prefixCls, style: style, onTap: onTap },
            React.createElement(one_1.View, { className: `${prefixCls}-verticality` },
                label ? (React.createElement(one_1.View, { className: `${prefixCls}-verticality-label`, style: labelStyle },
                    required ? React.createElement(one_1.Text, { className: `${prefixCls}-verticality-required` }, "*") : null,
                    label)) : null,
                React.createElement(one_1.View, { className: `${prefixCls}-verticality-value`, style: valueStyle }, children))));
    }
    return (React.createElement(one_1.View, { className: prefixCls, style: style, onTap: onTap },
        React.createElement(one_1.View, { className: `${prefixCls}-container` },
            React.createElement(one_1.View, { className: `${prefixCls}-container-main` },
                React.createElement(one_1.View, { className: classnames_1.default(`${prefixCls}-container-main-left`, {
                        [`${prefixCls}-container-main-left-input`]: field,
                    }) },
                    React.createElement(one_1.View, { className: `${prefixCls}-container-main-left-label` },
                        required ? (React.createElement(one_1.Text, { className: `${prefixCls}-container-main-left-label-required` }, "*")) : null,
                        icon ? (React.createElement(icon_1.default, { type: icon, size: "32px", style: { marginRight: '10px' }, color: "#333" })) : null,
                        label ? (React.createElement(one_1.Text, { className: `${prefixCls}-container-main-left-label-value`, style: labelStyle }, label)) : null)),
                React.createElement(one_1.View, { className: `${prefixCls}-container-main-right` },
                    React.createElement(one_1.View, { className: `${prefixCls}-container-main-right-value`, style: valueStyle }, children || children === 0 ? children : defaultNullValue),
                    arrow ? React.createElement(icon_1.default, { type: "right", style: { marginLeft: '10px' }, color: "#666" }) : null)),
            description ? (React.createElement(one_1.View, { className: `${prefixCls}-container-description` }, description)) : null),
        border ? React.createElement(one_1.View, { className: `${prefixCls}-border` }) : null));
};
exports.default = Cell;
